/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2361
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
var r = function (e, t) {
  this.parentContext = e
  this.rootRequest = t
}
exports.Plan = r
